import {
    Component,
    computed,
    effect,
    inject,
    input,
    output,
    viewChild,
} from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { DataTestIdPipe } from '@app/pipes/data-test-id/data-test-id-pipe';
import { IReadOnlyStepper } from '@app/types/readonly-stepper';

@Component({
    selector: 'app-bottom-sheet-wrapper',
    imports: [MatIconModule, MatStepperModule, DataTestIdPipe],
    templateUrl: './bottom-sheet-wrapper.component.html',
    styleUrls: ['./bottom-sheet-wrapper.component.scss'],
})
export class BottomSheetWrapperComponent {
    title = input<string>('');
    titleAlignment = input<'left' | 'center'>('left');
    readonlyStepper = input<IReadOnlyStepper>({
        selectedIndex: -1,
        completed: false,
        items: [],
    });
    width = input<number>(800);
    class = input<
        | {
              header: string;
              body: string;
          }
        | undefined
    >(undefined);
    onClose = output();
    nameId = computed(() => {
        return this.title().toLowerCase().replace(/ /g, '-');
    });

    titleClass = computed(() => {
        if (this.class() !== undefined) {
            return this.class()?.header;
        }
        return this.titleAlignment() === 'center'
            ? 'rcp-w-full rcp-text-center rcp-font-poppins rcp-text-2xl rcp-pl-10'
            : `rcp-w-full rcp-max-w-[${this.width()}px] rcp-font-poppins rcp-text-2xl`;
    });

    bodyClass = computed(() => {
        if (this.class() !== undefined) {
            return this.class()?.body;
        }
        return `rcp-mx-auto rcp-max-w-[${this.width()}px]`;
    });
    matStepper = viewChild(MatStepper);

    constructor() {
        effect(() => {
            const { selectedIndex, items } = this.readonlyStepper();
            if (items.length > 0) {
                {
                    const stepper = this.matStepper();
                    if (stepper != undefined) {
                        stepper.reset();
                        stepper.selectedIndex =
                            selectedIndex === -1 || selectedIndex === 0
                                ? 0
                                : selectedIndex - 1;
                    }
                }
            }
        });
    }

    readonly bottomSheetRef = inject(MatBottomSheetRef);

    onCloseClick(e: Event) {
        e.preventDefault();

        this.onClose.emit();
    }
}
